// Style UNIFORME pour tous les services / spécialités (plus de couleur par type).
const UNIFORM_SERVICE = { color: 'text-gray-700', bgColor: 'bg-gray-100', borderColor: 'border-gray-200' }
export const serviceColorMap: Record<string, { color: string; bgColor: string; borderColor: string }> =
  new Proxy({}, { get: () => UNIFORM_SERVICE })

export const serviceIconPaths: Record<string, string> = {
  'medecine-generale': 'M22 12h-4l-3 9L9 3l-3 9H2',
  'dentisterie': 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z',
  'audiologie': 'M9 9a3 3 0 0 1 6 0v6a3 3 0 0 1-6 0V9zM5 10a7 7 0 0 1 14 0',
  'kinesitherapie': 'M13 2L3 14h9l-1 8 10-12h-9l1-8z',
  'pediatrie': 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  'gynecologie': 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  'dermatologie': 'M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16z',
  'psychologie': 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  'nutrition': 'M12 2a9 9 0 0 1 9 9c0 3.87-2.44 7.17-6 8.48V22H9v-2.52C5.44 18.17 3 14.87 3 11a9 9 0 0 1 9-9z',
}

// Chips de services sur les cartes de centres — style uniforme neutre.
export const serviceNameColors: Record<string, string> =
  new Proxy({}, { get: () => 'bg-gray-100 text-gray-700' })

export const serviceNameColorsBordered: Record<string, string> =
  new Proxy({}, { get: () => 'bg-gray-100 text-gray-700 border-gray-200' })

const UNIFORM_SPECIALITE = { bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-200', iconColor: '#374151' }
export const specialiteColorMap: Record<string, { bg: string; text: string; border: string; iconColor: string }> =
  new Proxy({}, { get: () => UNIFORM_SPECIALITE })

export const categorieActualiteColors: Record<string, { color: string; bg: string }> = {
  'Actualité': { color: 'text-white', bg: 'bg-blue-600' },
  'Prévention': { color: 'text-white', bg: 'bg-green-600' },
  'Services': { color: 'text-white', bg: 'bg-purple-600' },
  'Conseils santé': { color: 'text-white', bg: 'bg-orange-500' },
  'Événement': { color: 'text-white', bg: 'bg-red-600' },
  'Pédiatrie': { color: 'text-white', bg: 'bg-teal-600' },
}

export const categoriePartenaireColors: Record<string, { color: string; bg: string }> = {
  'Institutionnel': { color: 'text-blue-700', bg: 'bg-blue-50' },
  'Mutualité': { color: 'text-green-700', bg: 'bg-green-50' },
  'Hospitalier': { color: 'text-purple-700', bg: 'bg-purple-50' },
  'Académique': { color: 'text-indigo-700', bg: 'bg-indigo-50' },
  'Associatif': { color: 'text-orange-700', bg: 'bg-orange-50' },
  'Social': { color: 'text-teal-700', bg: 'bg-teal-50' },
}

export const categorieRecrutementColors: Record<string, { color: string; bg: string }> = {
  'Médecine': { color: 'text-blue-700', bg: 'bg-blue-50' },
  'Rééducation': { color: 'text-purple-700', bg: 'bg-purple-50' },
  'Soins infirmiers': { color: 'text-green-700', bg: 'bg-green-50' },
  'Administration': { color: 'text-orange-700', bg: 'bg-orange-50' },
  'Dentisterie': { color: 'text-yellow-700', bg: 'bg-yellow-50' },
  'Psychologie': { color: 'text-indigo-700', bg: 'bg-indigo-50' },
}

// Retourne l'URL d'une image Payload media (object ou string)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getMediaUrl(media: any, fallback = '/assets/images/no_image.png'): string {
  if (!media) return fallback
  if (typeof media === 'string') return media
  return media.url || fallback
}

// Retourne le texte alternatif d'une image Payload media
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getMediaAlt(media: any, fallback = ''): string {
  if (!media) return fallback
  if (typeof media === 'string') return fallback
  return media.alt || fallback
}
